import React, { useEffect, useState } from "react";
import "./notifications.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import NoOneElement from "../../components/noOneElement/NoOneElement";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import SingleNotification from "../../components/singleNotification/SingleNotification";
import SearchInput from "../../components/searchInput/SearchInput";
import ContentMessage from "./components/contentMessage/ContentMessage";

import { Col, Row } from "react-bootstrap";
import { t } from "i18next";
import { setGlobalState, useGlobalState } from "../../utils/state";
import {
  getNotificationsWS,
  getSingleNotificationsWS,
} from "./api/notificationsApi";
import { isEmpty } from "../../utils/validation";
import { useScreenSize } from "../../ScreenSizeContext";
import AnswerQuestionDetails from "../../components/answerQuestionDetails/AnswerQuestionDetails";

const Notifications = () => {
  const isPC = useScreenSize();
  const [numberNotifications] = useGlobalState("numberNotifications");

  const [listNotifications, setListNotifications] = useState([]);
  const [filteredListNotifications, setFilteredListNotifications] = useState(
    []
  );
  const [dataNotification, setDataNotification] = useState({});
  const [selected, setSelected] = useState(0);

  const [search, setSearch] = useState("");

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 5);

    getNotificationsWS()
      .then((res) => {
        //Lista delle notifiche
        setListNotifications(res.notifications);
        setFilteredListNotifications(res.notifications);

        //Setto il numero di notifiche se per caso è variato
        setGlobalState("numberNotifications", res.number_notification);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const searchFunction = () => {
    if (search) {
      setFilteredListNotifications(
        listNotifications.filter((notification) => {
          const title = notification.title?.toLowerCase() || "";
          const body = notification.body?.toLowerCase() || "";

          return (
            title.includes(search.toLowerCase()) ||
            body.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilteredListNotifications(listNotifications);
    }
  };

  const handleClickNotification = ({ id, id_event, question }) => {
    setSelected(id);
    getSingleNotificationsWS({ id_notification: id, id_event, question })
      .then((res) => {
        setDataNotification(res);

        //Segno come già letta in locale
        setListNotifications((prevNotifications) =>
          prevNotifications.map((notif) =>
            notif.id === id ? { ...notif, displayed: 1 } : notif
          )
        );
        setFilteredListNotifications((prevNotifications) =>
          prevNotifications.map((notif) =>
            notif.id === id ? { ...notif, displayed: 1 } : notif
          )
        );

        //Aggiorno il numero di notifiche lette che apparirà sulla bottombar
        if (!res.displayed)
          setGlobalState("numberNotifications", numberNotifications - 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <HeaderBar title={t("notifications.title")} option={true} />
      {/*Se sono da MOBILE voglio che mi apra una pagina diversa per i dettagli
            e inoltre le card delle notifiche stanno su 1 o 2 colonne a seconda degli schermi */}
      {!isPC ? (
        <div className="container-notifications container-responsive">
          <SearchInput
            search={search}
            setSearch={setSearch}
            searchFunction={searchFunction}
          />
          {!isEmpty(filteredListNotifications) ? (
            <Row sm={1} md={1} className="list-notifications mt-2 g-2">
              {filteredListNotifications.map((item) => {
                console.log(item);
                return (
                  <Col sm={12} md={12} key={item.id}>
                    <SingleNotification
                      id={item.id}
                      id_event={item.id_event ? Number(item.id_event) : null}
                      image_type={item.image_type}
                      image={item.image}
                      title={item.title}
                      body={item.body}
                      datetime_sending={item.datetime_sending}
                      question={item.question ?? 0}
                      displayed={item.displayed}
                    />
                  </Col>
                );
              })}
            </Row>
          ) : (
            <NoOneElement
              title={t("common.oops")}
              subtitle={t("notifications.empty")}
            />
          )}
          <VoidSpace />
        </div>
      ) : (
        /*Se sono da PC invece voglio che se clicco su una card della notifica 
          mi deve mostrare sulla destra il contenuto di quest'ultima */
        <Row lg={2} xl={2} className="container-notifications">
          <Col lg={6} xl={6}>
            <Row sm={1} md={1} lg={1} xl={1}>
              <Col
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="d-flex justify-content-center w-100"
              >
                <SearchInput
                  search={search}
                  setSearch={setSearch}
                  searchFunction={searchFunction}
                />
              </Col>
            </Row>
            <div className="list-notifications">
              <Row sm={1} md={1} lg={1} xl={1} className="g-2 mt-2">
                {!isEmpty(filteredListNotifications)
                  ? filteredListNotifications.map((item) => (
                      <Col sm={12} md={12} lg={12} xl={12} key={item.id}>
                        <SingleNotification
                          id={item.id}
                          id_event={item.id_event}
                          image_type={item.image_type}
                          image={item.image}
                          title={item.title}
                          body={item.body}
                          question={item.question ?? 0}
                          datetime_sending={item.datetime_sending}
                          displayed={item.displayed}
                          handleClick={handleClickNotification}
                        />
                      </Col>
                    ))
                  : null}
              </Row>
            </div>
          </Col>

          <Col lg={6} xl={6} className="d-flex justify-content-center">
            {!isEmpty(selected) && !isEmpty(dataNotification) ? (
              dataNotification.id_question ? (
                <div className="w-100 container-on-right mt-3">
                  <div className="p-3">
                    <AnswerQuestionDetails
                      id={dataNotification.id_question}
                      image={
                        dataNotification.image
                          ? "data:" +
                            dataNotification.image_type +
                            ";base64," +
                            dataNotification.image
                          : "/no_img.png"
                      }
                      name={dataNotification.name_association}
                      datetime={dataNotification.datetime_sending}
                      question={dataNotification.title}
                      answer={dataNotification.body}
                    />
                  </div>
                </div>
              ) : (
                <ContentMessage dataNotification={dataNotification} />
              )
            ) : (
              <div className="w-100"></div>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default Notifications;
